import { useEffect } from "react";

interface TabLayoutProps {
    children: React.ReactNode;
    backgroundColor?: string;
}

const TabLayout = ({ children, backgroundColor }: TabLayoutProps) => {
    const isRTL = BResource.isRTL();

    useEffect(() => {
        Device.setBackgroundColor(1.0, 1.0, 1.0, 1.0);
        return () => {
            Device.setBackgroundColor(0.0, 0.0, 0.0, 0.0);
        };
    }, []);

    return (
        <div dir={isRTL ? 'rtl' : 'ltr'} className={`flex ctab tab-cont w-screen ${backgroundColor ?? 'bg-base-bg-default'} text-base-txt-primary`}>
            {children}
        </div>
    );
};

export default TabLayout;
